import React, { useEffect, useState } from 'react'
import { Menu } from 'antd'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { TranslationOutlined } from '@ant-design/icons'
import { UserActions, UserSelectors } from '~/Store/User'
import { useAppDispatch } from '~/Store/hooks'
import { UserInviteStatus } from '~/Services/UserService.d'
import { RootState } from '~/Store/reducers'

const { SubMenu, Item } = Menu

interface UserMenuProps {
  closeSelf: () => void
}

export const UserMenu = (props: UserMenuProps) => {
  const { closeSelf } = props
  const { t, i18n } = useTranslation()
  const dispatch = useAppDispatch()
  const history = useHistory()
  const preferences = useSelector(UserSelectors.getUserPreferences)
  const organizations = useSelector((state: RootState) =>
    UserSelectors.getUserOrganizationsByStatus(state, [
      UserInviteStatus.Accepted,
    ]),
  )
  const defaultOrg = useSelector(UserSelectors.getDefaultOrganization)
  const [selectedOrg, setSelectedOrg] = useState<string>(defaultOrg?.guid)
  const [currentLanguage, setCurrentLanguage] = useState<string>(i18n.language)

  useEffect(() => {
    setSelectedOrg(old => (defaultOrg ? defaultOrg.guid : old))
  }, [defaultOrg])

  const userLogout = () => {
    dispatch(UserActions.logout())
    closeSelf()
    history.replace('/login')
  }

  const changeOrganization = (event: any) => {
    const { key } = event
    
    // Nếu click vào language item, không đóng menu
    if (key === 'en' || key === 'vi') {
      return
    }
    
    // Nếu click vào logout hoặc language submenu
    if (key === 'logout' || key === 'language') {
      return
    }
    
    closeSelf()
    dispatch(UserActions.setAuthenticatedWithOrg(false))
    console.log('---------------')
    console.log(preferences)
    dispatch(
      UserActions.setUserPreferences({
        ...preferences,
        defaultOrganization: key,
      }),
    )
  }

  const changeLanguage = (event: any) => {
    const { key } = event
    if (key === 'en' || key === 'vi') {
      i18n.changeLanguage(key)
      setCurrentLanguage(key)
      localStorage.setItem('language', key)
    }
  }

  return (
    <Menu
      mode="inline"
      defaultOpenKeys={['organizations']}
      selectedKeys={[selectedOrg]}
      onClick={changeOrganization}
    >
      {organizations.length > 0 && (
        <>
          <SubMenu key="organizations" title={t('organizations')}>
            {organizations.map(org => (
              <Item key={org.guid}>{org.companyName}</Item>
            ))}
          </SubMenu>
          <Menu.Divider />
        </>
      )}
      
      <SubMenu 
        key="language" 
        title={t('language')} 
        icon={<TranslationOutlined />}
        onTitleClick={(e) => e.domEvent.stopPropagation()}
      >
        <Item 
          key="en" 
          onClick={changeLanguage}
          style={{ 
            backgroundColor: currentLanguage === 'en' ? '#e6f7ff' : 'transparent' 
          }}
        >
          English
        </Item>
        <Item 
          key="vi" 
          onClick={changeLanguage}
          style={{ 
            backgroundColor: currentLanguage === 'vi' ? '#e6f7ff' : 'transparent' 
          }}
        >
          Tiếng Việt
        </Item>
      </SubMenu>
      
      <Menu.Divider />
      
      <Item key="logout" onClick={userLogout}>
        {t('logout')}
      </Item>
    </Menu>
  )
}